import { render } from "./FixerDashboard.vue?vue&type=template&id=6336ce04&scoped=true"
import script from "./FixerDashboard.vue?vue&type=script&lang=js"
export * from "./FixerDashboard.vue?vue&type=script&lang=js"

import "./FixerDashboard.vue?vue&type=style&index=0&id=6336ce04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6336ce04"]])

export default __exports__